var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function () {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function () {
			$('#figureMessageModal').modal();
		}, 3000);
	}
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function () {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.heroWorker = function () {
	$("body").addClass("reveal");
	const heroOverlay = $(".hero-overlay");
	if (heroOverlay.length) {
		const elements = [".hero-image", ".promise-logo", ".leading-promise-logo", ".title", ".body", ".cta", ".tagline"];
		let delay = 800;
		let increment = 800;
		elements.forEach(element => {
			if (heroOverlay.find(element).length) {
				setTimeout(function () {
					heroOverlay.find(element).addClass("reveal");
				}, delay);
				delay += increment;
			}
		})
	}
	if ($("body.page-pages-wine").length) {
		$(".hero-section video").removeAttr("loop");
	}
}();

FIGURE.fullVideoSettings = function () {
	const fullVideoModal = $(".full-video-modal");
	if (!fullVideoModal.length) return;

	fullVideoModal.each((i, videoModalFull) => {
		const videoModal = $(videoModalFull);
		const fullModalVideo = videoModal.find("video")[0];
		const playBtn = videoModal.find(".play-video");

		const playEvent = function () {
			if (!videoModal.hasClass("started")) {
				fullModalVideo.play();
				playBtn.animate({ opacity: 0 }, 400, () => {
					playBtn.css("display", "none");
				});
				videoModal.addClass("started");
			}
		};

		const resetPlayEvent = function () {
			if (videoModal.hasClass("started")) {
				fullModalVideo.currentTime = 0;
				playBtn.css("display", "flex");
				setTimeout(() => {
					playBtn.animate({ opacity: 1 }, 400);
				}, 400);
				videoModal.removeClass("started");
			}
		};

		videoModal.on("hide.bs.modal", () => {
			fullModalVideo.pause();
			resetPlayEvent();
		});

		videoModal.find("video").on("play", () => {
			playEvent();
		});

		playBtn.on("click", () => {
			playEvent();
		});

		videoModal.find("video").on("ended", () => {
			resetPlayEvent();
		});
	});
}();

FIGURE.videoInlinePlayPause = function () {
	const $video = $(".content-groups .full-page-image video")[0];
	const $videoEl = $($video);
	if (!$videoEl.length) return;

	const videoSectionId = $videoEl.closest("section").attr("id");
	const $videoLink = $(".video-anchor-link");
	const $playBtn = $(".play-video-btn");
	const $pauseBtn = $(".pause-video-btn");
	const $playPauseContainer = $(".play-pause-container");

	// --- Helpers ---
	function showOverlay() {
		$playPauseContainer.removeClass("hiding hidden");
	}

	function hideOverlay() {
		$playPauseContainer.addClass("hiding");
		setTimeout(() => {
			$playPauseContainer.addClass("hidden");
		}, 300);
	}

	function setPlayState() {
		$playBtn.addClass("d-none");
		$pauseBtn.removeClass("d-none");
		hideOverlay();
	}

	function setPauseState() {
		$pauseBtn.addClass("d-none");
		$playBtn.removeClass("d-none");
		showOverlay();
	}

	// --- "Watch Full Video" link ---
	$videoLink.addClass("my-3 mx-auto mx-lg-0");
	const videoScrollTo = $(`<a href="#${videoSectionId}" class="scrollto">Watch Full Video</a>`)
	$(window).on("load resize", () => {
		if ($(window).width() < 1062) {
			videoScrollTo.attr("data-offset", 100);
		} else {
			videoScrollTo.attr("data-offset", '');
		}
	});
	$videoLink.append(videoScrollTo);
	$videoLink.on("click", () => {
		$video.muted = false;
		$video.currentTime = 0;
		$videoEl.addClass("audio-on video-started").removeClass("muted finished");
		setTimeout(() => {
			$video.play();
			setPlayState();
			hasStarted = true;
			manuallyPaused = false;
		}, 1000);
	});

	// --- Init ---
	$video.muted = true;
	setPauseState();

	let manuallyPaused = false;
	let hasStarted = false;

	function togglePlayPause() {
		if ($videoEl.hasClass("finished") || !hasStarted) {
			// Post-finish or first play: restart, unmute, play
			$video.currentTime = 0;
			$video.muted = false;
			$video.play();
			$videoEl.removeClass("finished");
			setPlayState();
			hasStarted = true;
			manuallyPaused = false;
		} else if ($video.paused) {
			$video.muted = false;
			$video.play();
			setPlayState();
			manuallyPaused = false;
		} else {
			$video.pause();
			setPauseState();
			manuallyPaused = true;
		}
	}

	// --- IntersectionObserver ---
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.intersectionRatio > 0.3) {
				if ($videoEl.hasClass("finished")) {
					// After finish: muted loop in background, overlay with play button
					$video.muted = true;
					$video.currentTime = 0;
					$video.play().catch(() => $video.play());
					setPauseState();
				} else if (!manuallyPaused) {
					$video.play().catch(() => $video.play());
					if (hasStarted) {
						setPlayState();
					}
				}
			} else {
				$video.pause();
			}
		});
	}, { threshold: 0.3 });

	observer.observe($video);

	// --- Click to play/pause ---
	const $videoContainer = $videoEl.closest(".carousel-item");

	$playPauseContainer.on("click", function (e) {
		e.stopPropagation();
		togglePlayPause();
	});

	$videoContainer.on("click", togglePlayPause);

	// --- On end: mute, loop, mark finished ---
	$videoEl.on("ended", function () {
		$video.muted = true;
		$video.currentTime = 0;
		$video.play();
		$videoEl.addClass("finished");
		setPauseState();
	});

	// const $progressBar = $(".video-progress-bar");
	//
	// $videoEl.on("timeupdate", function() {
	// 	const pct = ($video.currentTime / $video.duration) * 100;
	// 	$progressBar.css("width", pct + "%");
	// });
}();

FIGURE.labelRevealVideo = function () {
	if (!$("body").hasClass("page-pages-wine")) return;

	const $video = $("#label_reveal_image video")[0];
	const $videoEl = $($video);
	if (!$videoEl.length) return;

	const $btn = $("#label_reveal_image").find(".unmute-mute-btn");
	const $muteImg = $btn.find(".mute");
	const $unmuteImg = $btn.find(".unmute");

	let hasEnded = false;
	let userUnmuted = false;

	$video.muted = true;

	function setMuted() {
		$video.muted = true;
		$muteImg.css({ display: "flex", opacity: 1 });
		$unmuteImg.css({ display: "none", opacity: 0 });
	}

	function setUnmuted() {
		$video.muted = false;
		$muteImg.css({ display: "none", opacity: 0 });
		$unmuteImg.css({ display: "flex", opacity: 1 });
	}

	// Init
	setMuted();

	$btn.on("click", function (e) {
		e.stopPropagation();
		if ($video.muted) {
			setUnmuted();
			userUnmuted = true;
		} else {
			setMuted();
			userUnmuted = false;
		}
	});

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.intersectionRatio === 0) {
				$video.pause();
				if (hasEnded) {
					// Fully out of view after ending — reset
					$video.currentTime = 0;
					hasEnded = false;
				}
				if (userUnmuted) {
					setMuted();
				}
			}

			if (entry.intersectionRatio >= 0.5 && !hasEnded) {
				$video.play().catch(() => { });
				if (userUnmuted) {
					setUnmuted();
				}
			}
		});
	}, { threshold: [0, 0.5] });

	observer.observe($video);

	$videoEl.on("ended", function () {
		hasEnded = true;
		$video.currentTime = 0;
		$video.play();
		// $video.pause();
		setMuted();
		userUnmuted = false;
	});

}();

FIGURE.swiper = function () {
	const colSwiper = $(".col-swiper");
	if (colSwiper.length) {
		let swiper = null;
		const fullSwiper = colSwiper.hasClass("full-swiper");
		let options = {
			slidesPerView: 1.2,
			centeredSlides: true,
			grabCursor: true,
			pagination: {
				el: ".swiper-pagination",
				dynamicBullets: true,
				clickable: true
			},
			spaceBetween: 15,
			freeMode: true,
		}
		if ($(".col-swiper").data("off-center")) {
			options.centeredSlides = false;
		}
		if ($(".col-swiper").data("autoplay")) {
			const slideCount = $(".col-swiper .swiper-slide").length
			autoplay = {
				cssMode: false, // CRITICAL: Disable CSS mode for smooth transitions
				freeMode: {
					enabled: true,
					momentum: false, // Prevents acceleration/deceleration
				},
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
					pauseOnMouseEnter: true, // Optional: pause on hover
				},
				speed: 7500, // Adjust for desired speed, higher is slower
				loop: true,
				loopedSlides: slideCount, // CRITICAL: Helps with loop regeneration
				slidesPerView: 'auto',
				allowTouchMove: true,
			};
			options = { ...options, ...autoplay };
			// console.log({options})
		}
		function initSwiper() {
			if (fullSwiper) {
				if (!swiper) {
					swiper = new Swiper(".col-swiper", options);
				}
			} else {
				if (window.innerWidth < 768 && !swiper) { // Only initialize if screen width is below 768px and swiper not already initialized
					swiper = new Swiper(".col-swiper", options);
				}
				else if (window.innerWidth >= 768 && swiper) { // Destroy swiper if screen is 768px or wider
					swiper.destroy(true, true);
					swiper = null;
				}
			}
		}
		initSwiper(); // Initialize on page load
		window.addEventListener('resize', initSwiper);// Re-initialize on window resize
	}
}();

FIGURE.imagePositionTracker = function () {
	const imageIDs = ["ranch-map-image"];
	imageIDs.forEach((imageID) => {
		if ($(`#${imageID}`).length && $(`#${imageID}`).hasClass("coordinate-finder")) {
			const image = document.getElementById(imageID);
			image.addEventListener('click', (e) => {
				const rect = image.getBoundingClientRect();
				// Get click position relative to image
				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;
				// Convert to percentage (for responsive positioning)
				const xPercent = (x / rect.width) * 100;
				const yPercent = (y / rect.height) * 100;
				//
				console.log('Percentage coordinates:', `X: ${xPercent}%`, `Y: ${yPercent}%`);
				// Return or use the coordinates however you need
				return { x: xPercent, y: yPercent };
			});
		}
	});
}();

FIGURE.RanchMap = (function () {
	const container = document.getElementById('ranch-map-container');
	if (!container) return;

	const indicators = container.querySelectorAll('.map-indicator');

	function positionIndicators() {
		const containerRect = container.getBoundingClientRect();

		indicators.forEach(indicator => {
			const placement = indicator.dataset.placement || 'top';
			const distance = parseFloat(indicator.dataset.distance) || 5;

			const line = indicator.querySelector('.map-indicator-line');
			const label = indicator.querySelector('.map-indicator-label');

			// Convert distance percentage to pixels based on container height
			const distancePx = (distance / 100) * containerRect.height;

			// Reset styles
			line.style.cssText = '';
			label.style.cssText = '';

			// Base label styles that get overwritten positionally
			// label.style.padding = '8px 12px';
			// label.style.background = 'rgba(255, 255, 255, 0.9)';

			switch (placement) {
				case 'top':
					line.style.width = '1px';
					line.style.height = `${distancePx}px`;
					line.style.bottom = '0';
					line.style.left = '50%';
					line.style.transform = 'translateX(-50%)';
					label.style.bottom = `${distancePx}px`;
					label.style.left = '50%';
					label.style.transform = 'translateX(-50%)';
					break;

				case 'bottom':
					line.style.width = '1px';
					line.style.height = `${distancePx}px`;
					line.style.top = '0';
					line.style.left = '50%';
					line.style.transform = 'translateX(-50%)';
					label.style.top = `${distancePx}px`;
					label.style.left = '50%';
					label.style.transform = 'translateX(-50%)';
					break;

				case 'left':
					line.style.width = `${distancePx}px`;
					line.style.height = '1px';
					line.style.right = '0';
					line.style.top = '50%';
					line.style.transform = 'translateY(-50%)';
					label.style.right = `${distancePx}px`;
					label.style.top = '50%';
					label.style.transform = 'translateY(-50%)';
					break;

				case 'right':
					line.style.width = `${distancePx}px`;
					line.style.height = '1px';
					line.style.left = '0';
					line.style.top = '50%';
					line.style.transform = 'translateY(-50%)';
					label.style.left = `${distancePx}px`;
					label.style.top = '50%';
					label.style.transform = 'translateY(-50%)';
					break;

				case 'top left':
					line.style.width = '1px';
					line.style.height = `${distancePx}px`;
					line.style.bottom = '0';
					line.style.left = '50%';
					line.style.transform = 'translateX(-50%)';
					label.style.bottom = `${distancePx}px`;
					label.style.left = '50%';
					label.style.transform = 'translateX(-85%)';
					break;

				case 'top right':
					line.style.width = '1px';
					line.style.height = `${distancePx}px`;
					line.style.bottom = '0';
					line.style.left = '50%';
					line.style.transform = 'translateX(-50%)';
					label.style.bottom = `${distancePx}px`;
					label.style.left = '50%';
					label.style.transform = 'translateX(-15%)';
					break;

				case 'bottom left':
					line.style.width = '1px';
					line.style.height = `${distancePx}px`;
					line.style.top = '0';
					line.style.left = '50%';
					line.style.transform = 'translateX(-50%)';
					label.style.top = `${distancePx}px`;
					label.style.left = '50%';
					label.style.transform = 'translateX(-85%)';
					break;

				case 'bottom right':
					line.style.width = '1px';
					line.style.height = `${distancePx}px`;
					line.style.top = '0';
					line.style.left = '50%';
					line.style.transform = 'translateX(-50%)';
					label.style.top = `${distancePx}px`;
					label.style.left = '50%';
					label.style.transform = 'translateX(-15%)';
					break;
			}

			// Boundary correction after positioning
			correctLabelBoundary(label);
		});
	}

	function correctLabelBoundary(label) {
		requestAnimationFrame(() => {
			// Re-measure here, not from the outer scope
			const containerRect = container.getBoundingClientRect();
			const labelRect = label.getBoundingClientRect();

			if (containerRect.width === 0 || containerRect.height === 0) return;

			const labelLeft = labelRect.left - containerRect.left;
			const labelRight = labelRect.right - containerRect.left;
			const labelTop = labelRect.top - containerRect.top;
			const labelBottom = labelRect.bottom - containerRect.top;

			const containerWidth = containerRect.width;
			const containerHeight = containerRect.height;

			let offsetX = 0;
			let offsetY = 0;

			if (labelRight > containerWidth - 8) {
				offsetX = containerWidth - 8 - labelRight;
			} else if (labelLeft < 8) {
				offsetX = 8 - labelLeft;
			}

			if (labelBottom > containerHeight - 8) {
				offsetY = containerHeight - 8 - labelBottom;
			} else if (labelTop < 8) {
				offsetY = 8 - labelTop;
			}

			if (Math.abs(offsetX) > containerWidth || Math.abs(offsetY) > containerHeight) return;

			if (offsetX !== 0 || offsetY !== 0) {
				const currentTransform = label.style.transform || '';
				label.style.transform = `${currentTransform} translate(${offsetX}px, ${offsetY}px)`;
			}
		});
	}

	function debounce(func, wait) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}

	function init() {
		const image = document.getElementById('ranch-map-image');

		if (image && !image.complete) {
			image.addEventListener('load', () => {
				positionIndicators();
			});
		} else {
			positionIndicators();
		}

		window.addEventListener('resize', debounce(positionIndicators, 100));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	return { refresh: positionIndicators };
})();

FIGURE.stickyMemberButton = function () {
	const joinBtn = $("#join-membership-button");
	const btnFiller = $(".button-filler");
	if (joinBtn.length && btnFiller.length && btnFiller.data("reduce-by-id") === "join-membership-button") {
		const btnAdjuster = function () {
			const btnWidth = joinBtn.outerWidth();
			const btnFillerWidth = btnFiller.closest(".button-filler-col").innerWidth();
			const newBtnFillerWidth = $(window).width() < 992 ? "100%" : btnFillerWidth - btnWidth - 60;
			btnFiller.css({ width: newBtnFillerWidth });
		}
		btnAdjuster();
		$(window).on('resize', btnAdjuster);
	}
	$(window).on("scroll resize", function () {
		const ww = $(window).width();
		if (ww >= 768) {
			$(".dropdown-menu").each((i, dd) => {
				if ($(dd).hasClass("show")) {
					$(dd).dropdown("hide");
				}
			});
		}
	});
	$(".dropdown-menu").each((i, dd) => {
		if ($(dd).closest(".account-nav-mobile").length) {
			$(dd).find("a").on("click", (e) => {
				const target = $(e.target).closest("a");
				const href = target.attr("href");
				console.log({ target, href });
				if (href.length && href !== "#") {
					window.location.assign(href);
				}
			});
		}
	});
}();

FIGURE.signupNoTransparentHeader = function () {
	if ($("body.page-signup-index").length) {
		$("body.page-signup-index").removeClass("transparent-header");
	}
}();

FIGURE.membershipLoggedInRemoveLogin = function () {
	if ($(".page-club-index").length) {
		$(".content-groups a").each((i, a) => {
			if ($(a).attr("href").includes("login")) {
				if ($(".site-header .account-account").length) {
					$(a).closest(".col-md-auto").addClass("d-none");
				} else {
					$(a).addClass("account-login");
					$(a).attr("data-toggle", "modal");
					$(a).attr("data-target", "#figureModalMed");
					// $(a).attr("href", "#");
				}
			}
		});
	}
}();

FIGURE.faqWorker = function () {
	[$("#faqsAccordion"), $('#accountAccordion')].forEach(accordion => {
		if (accordion.length) {
			accordion.on('shown.bs.collapse', function (e) {
				var $listing = $(e.target).closest('.collapse-listing');
				console.log({ $listing });
				$('html, body').animate({
					scrollTop: $listing.offset().top - 100
				}, 700);
			});
		}
	})
}();